import { render } from "./SrhFaqPage.vue?vue&type=template&id=06bfcc86"
import script from "./SrhFaqPage.vue?vue&type=script&lang=js"
export * from "./SrhFaqPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__